import React from 'react'
import './styles.scss'
import { getCurrentLanguage } from '../../assets/js/functions'
import LogoMemoria from '../../assets/images/Logo-INM-inverted.png'
import LogoOroibidea from '../../assets/images/LogoVectorial.svg'
import LogoNavarra from '../../assets/images/logo GOB + Agenda 2030-B-01.png'

export default function Footer() {
  return (
    <footer>
        <a href={"https://www.navarra.es/"+getCurrentLanguage()} target="_blank">
            <img src={`${LogoNavarra}`}/>
        </a>
        <a href={"https://pazyconvivencia.navarra.es/"+getCurrentLanguage()+"/memoria"} target="_blank">
            <img src={`${LogoMemoria}`}/>
        </a>
        <a href={"https://oroibidea.es/"+getCurrentLanguage()} target="_blank">
            <img src={`${LogoOroibidea}`} alt="Logo Oroibidea"/>
        </a>
    </footer>
  )
}
